import { dynamicSort } from "./tableUtilities";

export const termMatches = (glossary, text, ignoreCase) => {
    // Escape special characters for regular expression
    const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');

    // Find all occurrences of terms in the text
    let matches = [];
    Object.keys(glossary).forEach(term => {
        const regex = new RegExp(`\\b${escapeRegExp(term)}\\b`, ignoreCase ? 'gi' : 'g');
        let match;
        while ((match = regex.exec(text)) !== null) {
            matches.push({ index: match.index, term, match: match[0], definitions: glossary[term].map(g => ({ def: g.definition, id: g.id })), length: term.length });
        }
    });

    // Sort matches by starting index and then by length in descending order
    matches.sort(dynamicSort(['index', '-length']));

    // Filter out overlapping terms
    let filteredMatches = [];
    let lastMatchEnd = 0;
    matches.forEach(match => {
        if (match.index >= lastMatchEnd) {
            filteredMatches.push(match);
            lastMatchEnd = match.index + match.length;
        }
    });

    return filteredMatches
}